module.exports = __webpack_public_path__ + "static/img/foltest_king.a14133a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/foltest_king.png
// module id = lGzx
// module chunks = 0